import type { UserResponse } from '../services/api';

/**
 * Domains to exclude from assignee lists (e.g. internal/test accounts).
 * Used by IntakeAssigneeFilter and IntakeUserAssignmentDialog.
 */
export const ASSIGNEE_IGNORED_DOMAINS: readonly string[] = [
  'rogerhealthcare.com',
  'rishavanand.com',
];

/**
 * Emails to exclude from assignee lists (e.g. internal/test accounts).
 * Used by IntakeAssigneeFilter and IntakeUserAssignmentDialog.
 */
export const ASSIGNEE_IGNORED_EMAILS: readonly string[] = [
  'stacknine.dev@gmail.com',
  'chefking2673@gmail.com',
  'aoliver@jwohhc.com',
  'yunusansari2001@gmail.com',
  // explicitly asked not to show as intake assignee for Compassionate
  'michaelfernandez@cchha.com',
];

/**
 * Filter users for assignee dropdowns using the shared ignore lists.
 */
export function filterAssigneeUsers(users: UserResponse[]): UserResponse[] {
  return users.filter(
    user =>
      !ASSIGNEE_IGNORED_DOMAINS.some(domain => user.email?.includes(domain)) &&
      !ASSIGNEE_IGNORED_EMAILS.some(email => user.email === email)
  );
}
